import { goTo } from '@tiendanube/nexo';
import nexo from '../nexoClient';

type NavigateOptions = { replace?: boolean } | undefined;
type NavigateFunction = (path: string, options?: NavigateOptions) => void;

let navigateRef: NavigateFunction | null = null;

export const setNavigator = (navigate: NavigateFunction): void => {
  navigateRef = navigate;
};

export const navigateTo = (path: string, options?: NavigateOptions): void => {
  if (navigateRef) {
    navigateRef(path, options);
    return;
  }

  try {
    if (typeof window !== 'undefined' && window.top) {
      window.top.location.href = path;
    } else if (typeof window !== 'undefined') {
      window.location.href = path;
    }
  } catch {
    if (typeof window !== 'undefined') {
      window.location.href = path;
    }
  }
};

export const goToNexo = (path: string): void => {
  try {
    goTo(nexo, path);
  } catch {
    navigateTo(path);
  }
};
